import React from "react";
import { SprintIcon, TicketsIcon } from "../Icons";
import ReleaseIcon from "../Icons/ReleaseIcon";

export const getProjectLinkIcon = (board: string) => {
  switch (board) {
    case "sprints":
      return <SprintIcon size={20} />;
    case "releases":
      return <ReleaseIcon size={20} />;
    case "tickets":
      return <TicketsIcon size={20} />;
    default:
      return;
  }
};
